<template>
  <main>
    <molecule-create-edit-contact-point-or-sale
      :hasEditPermission="hasUpdateNtdcContactPointPermission"
      class="create-edit-contact-point-or-sale-container"
      v-model="currentContactPointOrSaleDetail"
      :cardTitle="cardTitle"
      :isValidateContactTrigger="isValidateTrigger"
      @onUpdateProfilePicture="onUpdateProfilePicture"
      @onUpdateErrorAtCreateEditContactPointOrSale="
        onUpdateErrorAtCreateEditContactPointOrSale
      "
    ></molecule-create-edit-contact-point-or-sale>
    <molecule-create-edit-access
      v-if="isShowAccessList"
      v-model="currentContactPointOrSaleDetail.accesses"
      class="create-edit-contact-access-container mt-2"
      :locationOption="locationOption"
      :hasEditPermission="hasUpdateNtdcContactPointPermission"
    >
    </molecule-create-edit-access>
    <div
      v-if="hasUpdateNtdcContactPointPermission"
      class="d-flex justify-content-end py-2"
    >
      <atom-button
        buttonId="primary-confirm-customer-button"
        :isDisable="isDisableCreateOrSaveChangeButton"
        @click="onClickConfirmCreateEditContactPointOrSale"
      >
        {{ primaryButtonText }}
      </atom-button>
      <atom-button
        class="ml-1"
        buttonId="cancel-add-customer-button"
        buttonStyle="border"
        buttonColor="secondary"
        @click="onClickCancelCreateEditContactPointOrSale"
      >
        Cancel
      </atom-button>
    </div>
    <!-- start modal section -->
    <!-- start confirm create new contact point/sale modal section -->
    <molecule-modal-dialog
      modalId="modal-confirm-create-new-contact-point-or-sale"
      buttonTextLeft="Confirm"
      :isTextCenter="true"
      :textTitle="`Do you want to create\nNew Contact Point/Sale?`"
      :textSubtitle="`“${currentContactPointOrSaleDetail.firstName} ${currentContactPointOrSaleDetail.lastName}” will add to Contact Point/Sale list.`"
      @clickButtonLeft="onClickConfirmCreateNewContactPointOrSaleFromModal"
    >
    </molecule-modal-dialog>
    <!-- end confirm create new contact point/sale modal section -->

    <!-- start confirm edit contact point/sale modal section -->
    <molecule-modal-dialog
      modalId="modal-confirm-edit-contact-point-or-sale"
      buttonTextLeft="Save Change"
      :isTextCenter="true"
      :textTitle="`Do you want to Save Change?`"
      :textSubtitle="`“${currentContactPointOrSaleDetail.firstName} ${currentContactPointOrSaleDetail.lastName}” will be edited.`"
      @clickButtonLeft="onClickConfirmEditContactPointOrSaleFromModal"
    >
    </molecule-modal-dialog>
    <!-- end confirm edit contact point/sale modal section -->

    <!-- start confirm discard change modal when click back  -->
    <molecule-modal-dialog
      modalId="modal-confirm-discard-change"
      :isTextCenter="true"
      textTitle="Do you want to leave without finishing?"
      buttonTextLeft="Confirm"
      @clickButtonLeft="onClickConfirmDiscardChangeFromModal"
    >
    </molecule-modal-dialog>
    <!-- end confirm discard change modal when click back  -->

    <!-- end modal section -->
  </main>
</template>

<script>
const replacer = (key, value) =>
  value instanceof Object && !(value instanceof Array)
    ? Object.keys(value)
        .sort()
        .reduce((sorted, key) => {
          sorted[key] = value[key]
          return sorted
        }, {})
    : value

import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeCreateEditContactPointOrSale from "@/components/molecules/portal/idc/MoleculeCreateEditContactPointOrSale.vue"
import MoleculeCreateEditAccess from "@/components/molecules/portal/idc/MoleculeCreateEditAccess.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import { PermissionUser } from "@/constants/permission-user"
import mixinsUser from "@/mixins/mixinsUser"

export default {
  name: "OrganismIdcCreateEditContactPointOrSale.vue",
  components: {
    AtomButton,
    MoleculeCreateEditContactPointOrSale,
    MoleculeCreateEditAccess,
    MoleculeModalDialog,
  },
  props: {
    cardTitle: {
      type: String,
      required: true,
    },
    locationOption: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  emits: [
    "input",
    "onConfirmCreateNewContactPointOrSale",
    "onUpdateProfilePicture",
  ],
  mixins: [mixinsUser],
  data() {
    return {
      isValidateTrigger: false,
      isErrorOccur: false,
      defaultContactPointOrSaleDetail: {
        id: "",
        profilePicture: null,
        firstName: "",
        lastName: "",
        idType: null,
        idOrPassportNumber: "",
        role: null,
        email: {
          primary: { contactPointEmailId: null, email: "" },
          secondary: { contactPointEmailId: null, email: "" },
          third: { contactPointEmailId: null, email: "" },
        },
        phone: {
          primary: { contactPointPhoneId: null, phone: "" },
          secondary: { contactPointPhoneId: null, phone: "" },
          third: { contactPointPhoneId: null, phone: "" },
        },
        accesses: [],
      },
      currentContactPointOrSaleDetail: {
        id: "",
        profilePicture: null,
        firstName: "",
        lastName: "",
        idType: null,
        idOrPassportNumber: "",
        role: null,
        email: {
          primary: { contactPointEmailId: null, email: "" },
          secondary: { contactPointEmailId: null, email: "" },
          third: { contactPointEmailId: null, email: "" },
        },
        phone: {
          primary: { contactPointPhoneId: null, phone: "" },
          secondary: { contactPointPhoneId: null, phone: "" },
          third: { contactPointPhoneId: null, phone: "" },
        },
        accesses: [],
      },
    }
  },
  computed: {
    hasUpdateNtdcContactPointPermission() {
      return this.hasPermission(PermissionUser.WPM.NTDC_CONTACT_POINT_WRITE)
    },

    contactPointOrSaleDetail: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    contactPointOrSaleId() {
      return this.$route?.params?.id
    },
    primaryButtonText() {
      return this.hasValue(this.contactPointOrSaleId)
        ? "Save Change"
        : "Create New"
    },
    isShowAccessList() {
      return (
        this.currentContactPointOrSaleDetail?.role?.toLowerCase() === "customer"
      )
    },
    isDisableCreateOrSaveChangeButton() {
      return this.isValidateTrigger ? this.isErrorOccur : false
    },
  },
  watch: {
    contactPointOrSaleDetail: {
      deep: true,
      handler() {
        if (this.contactPointOrSaleId && this.contactPointOrSaleDetail) {
          this.cloneContactPointOrSaleDetail()
        }
      },
    },
  },
  methods: {
    cloneContactPointOrSaleDetail() {
      this.currentContactPointOrSaleDetail = {
        id: this.contactPointOrSaleDetail.contactPointId,
        profilePicture: this.contactPointOrSaleDetail.image,
        firstName: this.contactPointOrSaleDetail.firstname,
        lastName: this.contactPointOrSaleDetail.lastname,
        idType: this.contactPointOrSaleDetail.idType,
        idOrPassportNumber: this.contactPointOrSaleDetail.identification,
        role: this.toPascalCase(this.contactPointOrSaleDetail.contactType),
        email: {
          primary: this.contactPointOrSaleDetail.emails
            ? this.getContactPointOrSaleEmail(
                this.contactPointOrSaleDetail.emails[0]
              )
            : "",
          secondary: this.contactPointOrSaleDetail.emails
            ? this.getContactPointOrSaleEmail(
                this.contactPointOrSaleDetail.emails[1]
              )
            : "",
          third: this.contactPointOrSaleDetail.emails
            ? this.getContactPointOrSaleEmail(
                this.contactPointOrSaleDetail.emails[2]
              )
            : "",
        },
        phone: {
          primary: this.contactPointOrSaleDetail.phones
            ? this.getContactPointOrSalePhone(
                this.contactPointOrSaleDetail.phones[0]
              )
            : "",
          secondary: this.contactPointOrSaleDetail.phones
            ? this.getContactPointOrSalePhone(
                this.contactPointOrSaleDetail.phones[1]
              )
            : "",
          third: this.contactPointOrSaleDetail.phones
            ? this.getContactPointOrSalePhone(
                this.contactPointOrSaleDetail.phones[2]
              )
            : "",
        },
        accesses: this.contactPointOrSaleDetail.accesses,
      }
    },

    getContactPointOrSaleEmail(emailData) {
      return {
        contactPointEmailId: emailData?.contactPointEmailId || null,
        email: emailData?.email || null,
      }
    },

    getContactPointOrSalePhone(phoneData) {
      return {
        contactPointPhoneId: phoneData?.contactPointPhoneId || null,
        phone: phoneData?.phone || null,
      }
    },

    setCurrentToOriginContactPointOrSaleDetail() {
      Object.assign(
        this.contactPointOrSaleDetail,
        this.currentContactPointOrSaleDetail
      )
    },

    checkIsDataChangeFromDefault() {
      const defaultData = JSON.stringify(
        this.defaultContactPointOrSaleDetail,
        replacer
      )
      const currentData = JSON.stringify(
        this.currentContactPointOrSaleDetail,
        replacer
      )
      this.isDataChange = defaultData !== currentData
    },

    navigateTo(path) {
      this.$router.push(path)
    },

    onClickConfirmCreateEditContactPointOrSale() {
      this.isValidateTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccur) {
          if (this.contactPointOrSaleId) {
            this.modalId = "modal-confirm-edit-contact-point-or-sale"
          } else {
            this.modalId = "modal-confirm-create-new-contact-point-or-sale"
          }
          this.$bvModal.show(this.modalId)
        }
      })
    },

    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },

    onClickConfirmCreateNewContactPointOrSaleFromModal() {
      this.setCurrentToOriginContactPointOrSaleDetail()
      this.$emit("onConfirmCreateNewContactPointOrSale")
      this.closeModal()
    },

    onClickConfirmEditContactPointOrSaleFromModal() {
      this.setCurrentToOriginContactPointOrSaleDetail()
      this.$emit("onConfirmEditContactPointOrSale")
      this.closeModal()
    },

    onClickConfirmDiscardChangeFromModal() {
      this.closeModal()
      this.navigateTo("/internal/web-portal/idc/contact")
    },

    onClickCancelCreateEditContactPointOrSale() {
      this.checkIsDataChangeFromDefault()
      this.$nextTick(() => {
        if (this.isDataChange) {
          this.modalId = "modal-confirm-discard-change"
          this.$bvModal.show(this.modalId)
        } else {
          this.navigateTo("/internal/web-portal/idc/contact")
        }
      })
    },

    onUpdateErrorAtCreateEditContactPointOrSale(isErrorOccur) {
      this.isErrorOccur = isErrorOccur
    },

    onUpdateProfilePicture(profilePicture) {
      this.$emit("onUpdateProfilePicture", profilePicture)
    },

    hasValue(input) {
      return input !== null && input !== undefined && input.length !== 0
    },

    toPascalCase(words) {
      return words
        ? words.replace(/\w+/g, function (w) {
            return w[0].toUpperCase() + w.slice(1).toLowerCase()
          })
        : ""
    },
  },
}
</script>

<style lang="scss" scoped>
.create-edit-contact-point-or-sale-container
  ::v-deep
  input.vs__search::placeholder {
  color: #b9b9c3;
}
.create-edit-contact-point-or-sale-container,
.create-edit-contact-access-container {
  width: 100%;
  height: 100%;
  background: white;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
}
</style>
